import { Skeleton } from "@/shared/ui";
import CardSkeleton from "./CardSkeleton";
import FilterSkeleton from "./FilterSkeleton";

export default function ProjectsPageSkeleton() {
  return (
    <div className="flex gap-6">
      <div className="flex-1 min-w-0">
        <div className="flex items-center gap-3 mb-5">
          <Skeleton height={40} width={192} />
          <Skeleton height={16} width={100} />
          <div className="ml-auto flex gap-1">
            <Skeleton height={32} width={32} />
            <Skeleton height={32} width={32} />
          </div>
        </div>

        <div className="mb-8">
          <Skeleton height={24} width={180} borderRadius={8} />
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 mt-4">
            {Array.from({ length: 3 }, function renderInternalCardSkeleton(_, i) {
              return <CardSkeleton key={i} />;
            })}
          </div>
        </div>

        <div>
          <Skeleton height={24} width={180} borderRadius={8} />
          <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4 mt-4">
            {Array.from({ length: 3 }, function renderExternalCardSkeleton(_, i) {
              return <CardSkeleton key={i} />;
            })}
          </div>
        </div>
      </div>
      <FilterSkeleton />
    </div>
  );
}
